import React from 'react'
import Link from 'gatsby-link'
import ContentLeft from '../components/ContentLeft'
import ContentRight from '../components/ContentRight'

class Main extends React.Component {
  render() {

    let close = <div className="close" onClick={() => {this.props.onCloseArticle()}}></div>

    return (
      <div id="main">
        <ContentLeft location={this.props.location}/>
        <ContentRight children={this.props.children} location={this.props.location} />

      </div>
    )
  }
}

export default Main


// WEBPACK FOOTER //
// ./src/components/Main.js